import Lantai from "../../../../../components/categories/superadmin/master_data/lantai/Home"

export default function Home() {  
  return (
    <Lantai />
  );
}
